import { create } from "zustand";

// The upgrade prompt. `message` explains which trial limit was hit; null means paid-only enrichment.
export const useEnrichmentModalStore = create((set) => ({
  isOpen: false,
  message: null,
  openModal: (message = null) => set({ isOpen: true, message }),
  closeModal: () => set({ isOpen: false, message: null }),
}));
